import * as React from "react";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {RouteComponentProps} from "react-router-dom";
import "./styles.scss";
import Loading from "components/loading";
import {getRoutes, PaymentDetailsRoutes} from "Loans/routes";
import {getUserLoans} from "Loans/api";
import {setLoanList} from "Loans/actions";
import {Loan} from "Loans/interface";
import {websiteUrl} from "config";
import {getIdToken} from "service";
import {setAndroidTokenAndVersionBeforeRedirecting} from "utils/android";

interface IConnectProps {
  userId: number;
  dispatch?: (action: any) => void;
  isAndroid: boolean;
  loanList: Loan[];
  loanIndex: number;
  apiVersion: number;
  authExt: any;
  currentLocation: string;
}

const Loans = (props: IConnectProps & RouteComponentProps) => {
  const [isActive, setIsActive] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string>(null);
  const loanId = props.authExt.hasOwnProperty("loanId");
  const redirection = () => {
    let allQuery;
    if (props.authExt && Object.keys(props.authExt).length) {
      allQuery = Object.keys(props.authExt)
      .map((key) => `${key}=${props.authExt[key]}`)
      .join("&");
    }
    if (props.isAndroid) {
      const token = getIdToken();
      return location.replace(`${websiteUrl}/loans/#/?id_token=${token}${allQuery ? "&" + allQuery : ""}`);
    }
    return location.replace(`${websiteUrl}/loans/#/${allQuery ? "?" + allQuery : ""}`);
  };

  useEffect(() => {
    if (!loanId && (props.currentLocation === "/" || props.currentLocation.includes("/loans") || props.currentLocation.includes("/repaymentinfo"))) {
     redirection();
    } else {
      getLoanInfo();
    }
  }, []);

  useEffect(() => {
    props.location['state'] && props.location['state']['withdraw'] && getLoanInfo();
  },[props.location]);

  const getLoanInfo = async () => {
    setIsActive(true);
    try {
      const res = await getUserLoans();
      props.dispatch(setLoanList(res['loans']));
      setErrorMsg(null);
    } catch (err) {
      err.response && err.response.data ? setErrorMsg(err.response.data) : setErrorMsg('Something Went Wrong.');
    }
    setIsActive(false);
  };

  return(
      <>
        <Loading active={isActive}/>
        {props.loanList && !(!loanId &&
        (props.currentLocation === "/" || props.currentLocation.includes("/loans") || props.currentLocation.includes("/repaymentinfo")))
        && getRoutes(props.match.path)}
      </>
  );
};

const mapStateToProps = (state): IConnectProps => {
    return {
        userId: state.login.auth ? state.login.auth.userId : null,
        isAndroid: state.login.isAndroid,
        apiVersion: state.login.apiVersion,
        loanList: state.loanDetails['loansList'] ? state.loanDetails['loansList']: [],
        loanIndex: state.loanDetails.loanIndex,
        authExt: state.login.authExt,
        currentLocation: state.router.location.pathname,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(Loans);
